// src/components/Toast.js
import React, { useEffect } from "react";
import { CheckCircle } from "lucide-react";

const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000); // 2秒後自動消失
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <>
      <style>
        {`
          @keyframes slideUpFade {
            from { transform: translate(-50%, 100%); opacity: 0; }
            to { transform: translate(-50%, 0); opacity: 1; }
          }
        `}
      </style>
      <div
        className="fixed bottom-12 left-1/2 z-50 flex items-center gap-2 bg-slate-800/80 text-white px-6 py-3 rounded-full shadow-2xl backdrop-blur-sm pointer-events-none"
        style={{
          animation: "slideUpFade 0.3s ease-out forwards",
          transform: "translate(-50%, 0)",
        }}
      >
        <CheckCircle size={18} className="text-emerald-400" />
        <span className="text-sm font-medium tracking-wide">{message}</span>
      </div>
    </>
  );
};

export default Toast;
